/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconHandTwoFingers = createReactComponent("outline", "hand-two-fingers", "IconHandTwoFingers", [["path", { "d": "M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5", "key": "svg-0" }], ["path", { "d": "M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47", "key": "svg-1" }], ["path", { "d": "M14 10.5a1.5 1.5 0 0 1 3 0v1.5", "key": "svg-2" }], ["path", { "d": "M11 5.5v-2a1.5 1.5 0 1 1 3 0v8.5", "key": "svg-3" }]]);

export { IconHandTwoFingers as default };
//# sourceMappingURL=IconHandTwoFingers.mjs.map
